import { HydrateOption } from '@core/enums';
import ReactPropsHelper from '@helpers/ReactPropsHelper';
import { runWhenIdle } from '@helpers/scheduler';
import { isSSR } from '@helpers/ssr';
import { createElement } from 'react';
import { hydrate } from 'react-dom';
import 'regenerator-runtime/runtime';
export default function (component, componentName, options) {
    if (isSSR() || options.hydrate === HydrateOption.Never) {
        return component;
    }
    const configs = ReactPropsHelper.props.filter((x) => x.name.toLowerCase() === `components.${componentName.toLowerCase()}`);
    if (!configs || configs.length === 0) {
        return component;
    }
    for (let index = 0; index < configs.length; index++) {
        const config = configs[index];
        const container = document.querySelector(`#${config.id}:not(.hydrated)`);
        if (!container) {
            continue;
        }
        container.classList.add('hydrated');
        // Defer hydration to idle time (polyfilled on iOS Safari via runWhenIdle)
        // so it never runs synchronously on the critical path.
        runWhenIdle(() => {
            const element = createElement(component, config.props);
            hydrate(element, container);
        });
    }
    return component;
}
